<template>
    <span
        v-if="effectStartDate"
        :class="getEffectStartDateClass"
    >
        {{ effectStartDate | formatDateToDisplay }}
    </span>
    <span v-else> - </span>
</template>

<script>
import { dateFromStringSameOrBeforeNowConstraint } from "@/utils/validation";
import { formatDateToDisplay } from '@/utils/utils';

export default {
    name: "DueEffectStartDateSlot",
    props: {
        effectStartDate: {
            type: String,
            required: true
        },
        status: {
            type: String,
            required: true
        }
    },
    computed: {
        getEffectStartDateClass() {
            return (dateFromStringSameOrBeforeNowConstraint(this.effectStartDate) && this.status !== 'effective')
                ? 'color-red'
                : null
            ;
        }
    },
    filters: {
        formatDateToDisplay
    },
}
</script>
